module.exports = __webpack_public_path__ + "static/results-employsure-73eeff06f76d7685666fe9f61cc1a780.png";